import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['searchInput', 'results'];

    declare readonly searchInputTarget: HTMLInputElement;
    declare readonly resultsTarget: HTMLElement;

    private debounceTimer: ReturnType<typeof setTimeout> | null = null;

    async search(): Promise<void> {
        const q = this.searchInputTarget.value.trim();

        if (q.length < 2) {
            this.hideResults();
            return;
        }

        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
            try {
                const exclude = this.searchInputTarget.dataset.parentescoExclude ?? '';
                const url = `/registers/search?q=${encodeURIComponent(q)}${exclude ? '&exclude=' + exclude : ''}`;
                const res  = await fetch(url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                });
                const data = await res.json() as Array<{ id: number; name: string; sede: string }>;
                this.renderResults(data);
            } catch {
                this.hideResults();
            }
        }, 250);
    }

    private renderResults(items: Array<{ id: number; name: string; sede: string }>): void {
        if (items.length === 0) {
            this.resultsTarget.innerHTML = '<div class="p-2 text-muted small">Sin resultados</div>';
            this.resultsTarget.style.display = 'block';
            return;
        }

        this.resultsTarget.innerHTML = items.map((item) =>
            `<div class="p-2 border-bottom cursor-pointer"
                  style="cursor:pointer"
                  data-id="${item.id}"
                  data-name="${item.name.replace(/"/g, '&quot;')}"
                  data-action="click->parentesco#select">
               <strong>${item.name}</strong>
               ${item.sede ? `<small class="text-muted ms-1">(${item.sede})</small>` : ''}
             </div>`
        ).join('');

        this.resultsTarget.style.display = 'block';
    }

    select(event: Event): void {
        const el = event.currentTarget as HTMLElement;
        const id   = el.dataset.id ?? '';
        const name = el.dataset.name ?? '';

        this.searchInputTarget.value = name;

        const hiddenInput = this.element.querySelector<HTMLInputElement>('input[name*="relatedRegisterId"]');
        if (hiddenInput) { hiddenInput.value = id; }

        this.hideResults();
    }

    private hideResults(): void {
        this.resultsTarget.style.display = 'none';
        this.resultsTarget.innerHTML = '';
    }
}
